// extracted by mini-css-extract-plugin
module.exports = {"proxy":"dmbc-proxy"};